import isBrowser from 'utils/isBrowser';
import Logger from 'services/logger';

const getDeviceId = (withConsole?: boolean) => {
  try {
    return isBrowser && localStorage?.getItem('paa_did') || '';
  } catch (e) {
    Logger.error(e as string, withConsole);
  }
};

export default getDeviceId;
